import {
  Pagination as MantinePagination,
  type PaginationProps as MantinePaginationProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type PaginationProps = CoreComponentProps<MantinePaginationProps, 'div'>;

export function Pagination({ testId, view = "all", ...rest }: PaginationProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantinePagination data-testid={testId} {...rest} />;
}
